import React from 'react'
import { useSelector } from 'react-redux'

import TalktimeMonitor from 'components/Artefacts/TalktimeMonitor'
import { _isTeacher } from 'store/selectors/User'

import ActiveSpeaker from './components/ActiveSpeaker'
import Activities from './components/Activities'
import FilerUpload from './components/FilerUpload'
import ThreeDotMenu from './components/ThreeDotMenu'
import {
    Container,
    ActiveSpeakerWrapper,
    ButtonsContainer,
    ButtonWrapper,
} from './styles'

import Screenshare from '../LeftControls/components/Screenshare'
import Whiteboard from '../LeftControls/components/Whiteboard'

const studentControls = [
    TalktimeMonitor,
    Screenshare,
    FilerUpload,
    ThreeDotMenu,
]

const teacherControls = [
    TalktimeMonitor,
    Screenshare,
    Whiteboard,
    FilerUpload,
    Activities,
    ThreeDotMenu,
]

const RightControls = () => {
    const isTeacher = useSelector(_isTeacher)

    const controls = isTeacher ? teacherControls : studentControls

    return (
        <Container isTeacher={isTeacher}>
            <ActiveSpeakerWrapper>
                <ActiveSpeaker />
            </ActiveSpeakerWrapper>
            <ButtonsContainer>
                {controls.map((Control, index) => (
                    <ButtonWrapper key={`rcontrol-${index}`}>
                        <Control rightControl />
                    </ButtonWrapper>
                ))}
            </ButtonsContainer>
        </Container>
    )
}

export default RightControls
